import { CartLayout } from "@features/layout";

export const CartPage = () => {
  return <CartLayout />;
};
